import { AppBar, Toolbar, useTheme } from '@mui/material';
import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

interface HeaderProps {
  children?: React.ReactNode;
  leftContent?: React.ReactNode;
  centerContent?: React.ReactNode;
  shouldShiftDownCenterContent?: boolean;
  rightContent?: React.ReactNode;
  isFixed?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  leftContent,
  centerContent,
  shouldShiftDownCenterContent = false,
  rightContent,
  isFixed = false,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <header>
      <div>
        <AppBar
          position={isFixed ? 'fixed' : 'static'}
          sx={{
            boxShadow: 'inset 0px -1px 0px ' + theme.palette.grey[300],
            backgroundColor: theme.palette.background.paper,
            width: '100%',
          }}
        >
          <Toolbar
            disableGutters
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              maxWidth: '1312px',
              width: '100%',
              margin: '0 auto',
              px: 2,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {leftContent}
            </div>
            {(!isSmallScreen || !shouldShiftDownCenterContent) && (
              <div
                style={{
                  flexGrow: 1,
                  textAlign: 'center',
                }}
              >
                {centerContent}
              </div>
            )}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {rightContent}
            </div>
          </Toolbar>
        </AppBar>
        {/* Spacer offsets the fixed AppBar so page content isn't hidden beneath it */}
        {isFixed && <Toolbar />}
        {shouldShiftDownCenterContent && isSmallScreen && (
          <div
            style={{
              marginTop: '0.5rem',
              marginBottom: '0.5rem',
              flexGrow: 1,
              textAlign: 'center',
            }}
          >
            {centerContent}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
